import styled from "styled-components";

export const ImageComponent = styled.img`
    width : 150px;
    height:  auto;
    object-fit: cover;
`